import Form from 'src/utils/Form.js'

class Pair extends Form {
    constructor(data, config = null) {
        super(data, config || Form.config)
    }

    fetch(then) {
        return super.get(`pairs/${this.id}/edit`).then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    static all(parameters, then) {
        return new Form().get(`pairs?${parameters}`).then(then)
    }

    create(then) {
        this.exchange_id = typeof this.exchange_id === 'object' && this.exchange_id !== null ? this.exchange_id.id : this.exchange_id
        return super.post('pairs').then(then)
    }

    update(then) {
        this.exchange_id = typeof this.exchange_id === 'object' && this.exchange_id !== null ? this.exchange_id.id : this.exchange_id
        return super.put(`pairs/${this.id}`).then(then)
    }

    destroy(then) {
        return super.delete(`pairs/${this.id}`).then(then)
    }
}

export default Pair;
